import {FC, useEffect, useState} from 'react'
import {Input} from '../Input/Input'
import Swal from 'sweetalert2'
import {lojaAgregador} from '../../pages/Agregador/lojas/create'
import {LittleButton} from '../Button/LittleButton'

type Props = {
  next: () => void
  back: () => void
  data: lojaAgregador
  setData: (value: any) => any
  categories: any[]
}

const ConfigLoja: FC<Props> = ({next, back, data, setData, categories}) => {
  const [name, setName] = useState(data.name)
  const [status, setStatus] = useState(data.active)
  const [order, setOrder] = useState(data.order)
  const [linkInterno, setLinkInterno] = useState('')
  const [linkExterno, setLinkExterno] = useState('')
  const [store, setStore] = useState(data.exclusive ? 'intern' : 'extern')
  const [description, setDescription] = useState(data.description)

  const [categoryParent, setCategoryParent] = useState([
    {select: 'Selecione uma categoria', value: -1},
  ])
  const [subCategory, setSubCategory] = useState([
    {select: 'Selecione uma subCategoria', value: -1},
  ])

  const [subCategorySelected, setSubCategorySelected] = useState(data.classificationId)

  const [categorySelected, setCategorySelected] = useState(-1)

  function mountSelect() {
    try {
      const optionsCategory = [{select: 'Selecione', value: -1}]
      categories
        .filter((el) => el.parent === null)
        .forEach((el: any) => {
          optionsCategory.push({
            select: el.shortname,
            value: el.code,
          })
        })

      setCategoryParent(optionsCategory)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    mountSelect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function nextPage() {
    if (
      !name ||
      !order ||
      !store ||
      !description ||
      !(store && (!linkInterno || !linkExterno)) ||
      !subCategorySelected ||
      // eslint-disable-next-line eqeqeq
      subCategorySelected == '-1'
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Verifique os campos faltantes',
      })
      return
    }
    const newData = data

    newData.name = name
    newData.order = order
    newData.active = status
    newData.classificationId = subCategorySelected.toString()

    if (store === 'intern') {
      newData.exclusive = true
      newData.link = linkInterno
    } else {
      newData.exclusive = false
      newData.link = linkExterno
    }

    //newData.link = name;
    newData.description = description
    setData(newData)

    next()
  }

  function setCategory() {
    try {
      // eslint-disable-next-line eqeqeq
      const subCategory = categories.find((el) => el.id == data.classificationId)
      setCategorySelected(categories.find((el) => el.code === subCategory.parent).code)

      setSubCategorySelected(subCategory?.id)
    } catch (error) {}
  }

  function changeSubcategories() {
    try {
      if (data.classificationId) {
        //setCategory()
      }

      if (categorySelected) {
        const options: any[] = [{select: 'Selecione', value: -1}]

        categories
          .filter((el) => el.parent === categorySelected)
          .forEach((el) => {
            options.push({
              select: el.shortname,
              value: el.id,
            })
          })

        setSubCategory(options)
      } else {
        setSubCategory([{select: 'Selecione', value: -1}])
      }

      setSubCategorySelected(data.classificationId)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    changeSubcategories()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categorySelected])

  useEffect(() => {
    data.exclusive ? setLinkInterno(data.link) : setLinkExterno(data.link)

    setCategory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <div className='card mt-5' style={{padding: '2rem 5rem'}}>
      <div>
        <h3>Configuração da Loja</h3>
        <span>Aqui você configura as principais informações da Loja.</span>
      </div>

      <div className='row'>
        <div className='col d-flex flex-column border-end'>
          <Input
            inputAttr={{
              type: 'select',
            }}
            label={'Categoria'}
            options={categoryParent}
            value={categorySelected}
            change={(value: any) => {
              setCategorySelected(value)
            }}
          />

          <Input
            inputAttr={{
              type: 'select',
            }}
            label={'SubCategoria'}
            options={subCategory}
            value={subCategorySelected}
            change={(value: any) => {
              setSubCategorySelected(value)
            }}
          />

          <Input
            inputAttr={{
              type: 'default',
            }}
            label={'Nome da Loja'}
            placeholder='Nome da Loja'
            value={name}
            change={(value: any) => {
              setName(value)
            }}
          />
        </div>

        <div className='col d-flex flex-column ' style={{gap: '62px'}}>
          <div className='d-flex justify-content-end' style={{gap: '62px'}}>
            <div className='d-flex flex-column' style={{gap: '15px'}}>
              <div className='d-flex align-items-center'>
                <Input
                  inputAttr={{
                    type: 'newRadio',
                  }}
                  search
                  label={'Loja Interna'}
                  value={'intern'}
                  checked={store === 'intern'}
                  change={(value: any) => {
                    setStore('intern')
                    setLinkExterno('')
                  }}
                />
                {exclusiveSvg}
              </div>
              <Input
                inputAttr={{
                  type: 'link',
                }}
                search
                label={'Link :'}
                value={linkInterno}
                change={(value: any) => {
                  setLinkInterno(value)
                }}
              />
            </div>
            <div className='d-flex flex-column' style={{gap: '15px'}}>
              <Input
                inputAttr={{
                  type: 'newRadio',
                }}
                search
                label={'Loja Externa'}
                value={'extern'}
                checked={store === 'extern'}
                change={(value: any) => {
                  setStore('extern')
                  setLinkInterno('')
                }}
              />
              <Input
                inputAttr={{
                  type: 'link',
                }}
                search
                label={'Link :'}
                value={linkExterno}
                //checked={}
                change={(value: any) => {
                  setLinkExterno(value)
                }}
              />
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-end' style={{gap: '62px'}}>
            <div className='' style={{width: '220px'}}>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                search
                label={'Ativo'}
                value={status}
                checked={status}
                checkSwift={true}
                change={(value: any) => {
                  setStatus(value)
                }}
              />
            </div>

            <Input
              inputAttr={{
                type: 'number',
              }}
              minNumber={0}
              label={'Ordem'}
              value={order}
              //checked={}
              change={(value: any) => {
                setOrder(value)
              }}
            />
          </div>
        </div>
      </div>
      <div className='row'>
        <Input
          inputAttr={{
            type: 'textarea',
          }}
          backgroundColor={'#EEF0F8'}
          label={'Descrição - Slogan ou resumo sobre a loja.'}
          value={description}
          change={(value: any) => {
            setDescription(value)
          }}
        />
      </div>
      <div className='d-flex  gap-5 justify-content-between mt-5'>
        <LittleButton
          text={'voltar'}
          color={'info'}
          click={() => back()}
          width='110px'
          height='35px'
        />
        <LittleButton
          text={'Próximo'}
          color={'primary'}
          click={() => nextPage()}
          width='110px'
          height='35px'
        />
      </div>
    </div>
  )
}

export {ConfigLoja}

const exclusiveSvg = (
  <svg width='50' height='25' viewBox='0 0 60 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g filter='url(#filter0_d_4006_16289)'>
      <path
        d='M53.1524 3H13.9824C13.4924 3 13.0224 3.22 12.6724 3.6L5.54244 11.54C4.82244 12.34 4.82244 13.65 5.54244 14.45L12.6724 22.39C13.0224 22.78 13.4924 22.99 13.9824 22.99H53.1524C54.1724 22.99 55.0024 22.07 55.0024 20.93V5.06C55.0024 3.92 54.1724 3 53.1524 3ZM14.5924 15.06C13.4224 16.23 11.5224 16.23 10.3524 15.06C9.18244 13.89 9.18244 11.99 10.3524 10.82C11.5224 9.65 13.4224 9.65 14.5924 10.82C15.7624 11.99 15.7624 13.89 14.5924 15.06Z'
        fill='#F5F5F5'
        stroke='#677484'
        stroke-miterlimit='10'
      />
      <path
        d='M9.71246 13.3798C10.8825 12.8798 12.0125 12.8698 12.8025 13.4698C14.3325 14.6198 14.0425 17.5898 12.1625 20.0898C10.2825 22.5898 7.51246 23.6898 5.98246 22.5398C4.45246 21.3898 4.74246 18.4198 6.62246 15.9198'
        stroke='#677484'
        stroke-miterlimit='10'
      />
    </g>
    <path
      d='M26.3529 12.1672C26.2894 12.1672 26.2259 12.1533 26.1687 12.1187C26.1116 12.0841 26.0735 12.0357 26.0608 11.9665L24.4607 6.3326C24.4607 6.3326 24.4543 6.29799 24.4543 6.27723C24.4543 6.22878 24.467 6.18725 24.4988 6.15265C24.5305 6.11804 24.5686 6.09036 24.6131 6.07651C24.6575 6.05575 24.702 6.04883 24.7528 6.04883C24.8036 6.04883 24.8417 6.06267 24.8734 6.08343C24.9115 6.1042 24.9369 6.1388 24.9496 6.19417L26.3592 11.2951L27.7625 6.19417C27.7752 6.14573 27.8006 6.11112 27.8323 6.08343C27.8641 6.06267 27.9022 6.04883 27.953 6.04883C28.0038 6.04883 28.0419 6.06267 28.0927 6.08343C28.1371 6.1042 28.1752 6.13188 28.2133 6.16649C28.245 6.20109 28.2641 6.24262 28.2641 6.29107C28.2641 6.29107 28.2641 6.30491 28.2641 6.31183C28.2641 6.31876 28.2577 6.3326 28.2514 6.33952L26.6767 11.9734C26.6577 12.0426 26.6196 12.091 26.5561 12.1257C26.4926 12.1603 26.4354 12.1741 26.3719 12.1741L26.3529 12.1672Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M29.2039 12.1187C29.1468 12.1187 29.096 12.098 29.0452 12.0634C28.9944 12.0288 28.9753 11.9734 28.9753 11.9042V6.25646C28.9753 6.18725 29.0007 6.1388 29.0452 6.1042C29.096 6.06959 29.1468 6.04883 29.2039 6.04883H31.9152C31.9787 6.04883 32.0295 6.07651 32.0612 6.12496C32.093 6.18033 32.1057 6.22878 32.1057 6.28415C32.1057 6.35336 32.0866 6.41565 32.0549 6.47102C32.0231 6.52639 31.9723 6.54716 31.9152 6.54716H29.477V8.83116H30.6707C30.7342 8.83116 30.7786 8.85884 30.8104 8.90729C30.8421 8.95574 30.8612 9.01803 30.8612 9.08032C30.8612 9.12877 30.8485 9.17722 30.8167 9.23259C30.785 9.28104 30.7405 9.30872 30.6707 9.30872H29.477V11.6066H31.9152C31.9787 11.6066 32.0231 11.6342 32.0549 11.6827C32.0866 11.7311 32.1057 11.7934 32.1057 11.8626C32.1057 11.9249 32.093 11.9803 32.0612 12.0357C32.0295 12.091 31.985 12.1118 31.9152 12.1118H29.2039V12.1187Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M33.096 12.1187C33.0325 12.1187 32.969 12.098 32.9182 12.0634C32.8674 12.0288 32.842 11.9734 32.842 11.9042V6.25646C32.842 6.18033 32.8674 6.12496 32.9182 6.09728C32.969 6.06959 33.0262 6.04883 33.096 6.04883C33.1595 6.04883 33.2103 6.06959 33.2548 6.1042C33.2992 6.1388 33.3437 6.18725 33.3818 6.24262C33.4199 6.29799 33.458 6.36028 33.4897 6.43642L35.547 10.8522V6.24954C35.547 6.18033 35.5724 6.12496 35.6232 6.09728C35.674 6.06959 35.7311 6.04883 35.8009 6.04883C35.8644 6.04883 35.9216 6.06267 35.9724 6.09728C36.0232 6.13188 36.0549 6.18033 36.0549 6.24954V11.9042C36.0549 11.9734 36.0295 12.0288 35.9724 12.0634C35.9216 12.098 35.8644 12.1187 35.8009 12.1187C35.7311 12.1187 35.6676 12.0841 35.6105 12.0218C35.5533 11.9526 35.5089 11.8834 35.4644 11.8073L33.3437 7.31541V11.9111C33.3437 11.9803 33.3183 12.0357 33.2611 12.0703C33.2103 12.1049 33.1532 12.1257 33.0897 12.1257L33.096 12.1187Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M37.4393 12.1186C37.3758 12.1186 37.3186 12.0979 37.2742 12.0633C37.2297 12.0218 37.2107 11.9733 37.2107 11.911V6.24946C37.2107 6.19409 37.2297 6.14564 37.2742 6.11103C37.3186 6.06951 37.3694 6.05566 37.4393 6.05566H38.7854C39.0838 6.05566 39.3569 6.11103 39.5981 6.22869C39.8394 6.34636 40.0299 6.53323 40.1696 6.79623C40.3093 7.05924 40.3791 7.39838 40.3791 7.8275V10.3537C40.3791 10.7829 40.3093 11.1289 40.1696 11.3919C40.0299 11.6549 39.8394 11.8418 39.5981 11.9595C39.3569 12.0771 39.0838 12.1325 38.7854 12.1325H37.4393V12.1186ZM37.7123 11.6134H38.7854C39.1283 11.6134 39.395 11.5096 39.5854 11.3089C39.7759 11.1012 39.8775 10.7829 39.8775 10.3468V7.82057C39.8775 7.39146 39.7823 7.07308 39.5854 6.86545C39.395 6.65781 39.1283 6.56091 38.7854 6.56091H37.7123V11.6203V11.6134Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M41.338 12.1184C41.2999 12.1184 41.2554 12.1114 41.211 12.0907C41.1665 12.0699 41.1284 12.0422 41.0967 12.0076C41.0649 11.973 41.0522 11.9315 41.0522 11.89C41.0522 11.8692 41.0522 11.8484 41.0586 11.8346L42.6523 6.19379C42.6714 6.12458 42.7095 6.07613 42.7666 6.04845C42.8238 6.02076 42.8809 6 42.9508 6C43.0206 6 43.0841 6.01384 43.1476 6.04845C43.2048 6.08305 43.2429 6.1315 43.2556 6.18687L44.8429 11.8277C44.8429 11.8277 44.8493 11.8623 44.8493 11.8761C44.8493 11.9176 44.8366 11.9592 44.8048 11.9938C44.7731 12.0284 44.735 12.0561 44.6906 12.0837C44.6461 12.1045 44.5953 12.1184 44.5445 12.1184C44.5064 12.1184 44.4683 12.1045 44.4302 12.0837C44.3921 12.063 44.3731 12.0284 44.3604 11.973L44.0048 10.6926H41.9031L41.5539 11.973C41.5412 12.0215 41.5158 12.0561 41.4777 12.0837C41.4396 12.1045 41.4015 12.1184 41.3507 12.1184H41.338ZM42.0174 10.2219H43.8715L42.9508 6.87207L42.0237 10.2219H42.0174Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M19.2286 20.2164C19.1714 20.2164 19.1206 20.1956 19.0698 20.161C19.019 20.1264 19 20.071 19 20.0018V14.3541C19 14.2849 19.0254 14.2365 19.0698 14.2019C19.1206 14.1672 19.1714 14.1465 19.2286 14.1465H21.9399C22.0034 14.1465 22.0541 14.1742 22.0859 14.2226C22.1176 14.278 22.1303 14.3264 22.1303 14.3818C22.1303 14.451 22.1113 14.5133 22.0795 14.5687C22.0478 14.624 21.997 14.6448 21.9399 14.6448H19.5016V16.9288H20.6953C20.7588 16.9288 20.8033 16.9565 20.835 17.0049C20.8668 17.0534 20.8858 17.1157 20.8858 17.178C20.8858 17.2264 20.8731 17.2749 20.8414 17.3302C20.8096 17.3787 20.7652 17.4064 20.6953 17.4064H19.5016V19.7042H21.9399C22.0034 19.7042 22.0478 19.7319 22.0795 19.7804C22.1113 19.8288 22.1303 19.8911 22.1303 19.9603C22.1303 20.0226 22.1176 20.078 22.0859 20.1333C22.0541 20.1887 22.0097 20.2095 21.9399 20.2095H19.2286V20.2164Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M22.7716 20.2235C22.7271 20.2235 22.6763 20.2096 22.6319 20.1889C22.5811 20.1612 22.543 20.1335 22.5112 20.092C22.4795 20.0505 22.4668 20.0089 22.4668 19.9605C22.4668 19.9189 22.4795 19.8774 22.5049 19.829L23.8129 17.1781L22.5239 14.5481C22.4922 14.4789 22.4795 14.4235 22.4795 14.3751C22.4795 14.3266 22.4922 14.2851 22.5239 14.2436C22.5493 14.2089 22.5874 14.1813 22.6319 14.1605C22.6763 14.1397 22.7208 14.1328 22.7716 14.1328C22.8351 14.1328 22.8922 14.1605 22.9303 14.2228C22.9684 14.2851 23.0065 14.3474 23.0383 14.4166L24.1304 16.7006L25.2289 14.4166C25.2606 14.3474 25.2987 14.2851 25.3368 14.2228C25.3813 14.1605 25.4321 14.1328 25.4955 14.1328C25.5463 14.1328 25.5908 14.1397 25.6352 14.1605C25.6797 14.1813 25.7114 14.2089 25.7432 14.2436C25.7686 14.2782 25.7876 14.3197 25.7876 14.3751C25.7876 14.4304 25.7749 14.4858 25.7432 14.5481L24.4479 17.1781L25.7686 19.829C25.794 19.8774 25.8067 19.9259 25.8067 19.9605C25.8067 20.0089 25.794 20.0574 25.7622 20.092C25.7305 20.1335 25.6924 20.1612 25.6479 20.1889C25.6035 20.2166 25.5527 20.2235 25.5019 20.2235C25.4511 20.2235 25.4067 20.1958 25.3622 20.1335C25.3241 20.0781 25.286 20.0158 25.2606 19.9605L24.1304 17.6349L23.0129 19.9605C22.9875 20.0158 22.9557 20.0712 22.9176 20.1335C22.8795 20.1889 22.8351 20.2235 22.7779 20.2235H22.7716Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M28.01 20.2649C27.7243 20.2649 27.4639 20.2096 27.2227 20.0919C26.9814 19.9742 26.7909 19.7874 26.6448 19.5244C26.5052 19.2613 26.429 18.9153 26.429 18.4862V15.9115C26.429 15.4824 26.4988 15.1432 26.6448 14.8802C26.7909 14.6172 26.9814 14.4303 27.2227 14.3127C27.4639 14.195 27.7306 14.1396 28.0164 14.1396C28.3529 14.1396 28.6386 14.2019 28.8672 14.3334C29.1021 14.458 29.2799 14.6311 29.4069 14.8387C29.5339 15.0463 29.591 15.2816 29.591 15.5308C29.591 15.6623 29.572 15.7523 29.5276 15.7938C29.4831 15.8353 29.4196 15.863 29.3434 15.863C29.2545 15.863 29.1847 15.8423 29.1466 15.8007C29.1085 15.7592 29.0894 15.7108 29.0894 15.6554C29.0894 15.5654 29.0704 15.4616 29.0386 15.3509C29.0132 15.2332 28.9624 15.1225 28.8862 15.0186C28.81 14.9148 28.7085 14.8248 28.5688 14.7556C28.4291 14.6864 28.2449 14.6518 28.0227 14.6518C27.6671 14.6518 27.3941 14.7556 27.21 14.9564C27.0195 15.164 26.9306 15.4824 26.9306 15.9115V18.4862C26.9306 18.9222 27.0258 19.2475 27.2163 19.4482C27.4068 19.6559 27.6862 19.7528 28.0481 19.7528C28.2767 19.7528 28.4545 19.7181 28.5878 19.6489C28.7212 19.5797 28.8227 19.4967 28.8862 19.3929C28.9561 19.289 29.0005 19.1783 29.0259 19.0606C29.0513 18.943 29.0704 18.8322 29.0894 18.7353C29.0894 18.6661 29.1148 18.6108 29.1593 18.5761C29.1974 18.5415 29.2609 18.5208 29.3371 18.5208C29.426 18.5208 29.4895 18.5415 29.5339 18.59C29.5783 18.6384 29.5974 18.7284 29.5974 18.8599C29.5974 19.1091 29.5339 19.3375 29.4069 19.552C29.2799 19.7666 29.0958 19.9396 28.8608 20.0642C28.6259 20.1888 28.3402 20.258 28.0037 20.258L28.01 20.2649Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M30.7149 20.2164C30.6578 20.2164 30.607 20.1956 30.5562 20.161C30.5054 20.1264 30.4863 20.071 30.4863 20.0018V14.3472C30.4863 14.278 30.5117 14.2226 30.5625 14.1949C30.6133 14.1672 30.6705 14.1465 30.7403 14.1465C30.8038 14.1465 30.861 14.1603 30.9118 14.1949C30.9625 14.2295 30.9943 14.278 30.9943 14.3472V19.7111H33.1659C33.2293 19.7111 33.2674 19.7388 33.2928 19.7873C33.3182 19.8426 33.3309 19.898 33.3309 19.9603C33.3309 20.0295 33.3182 20.0849 33.2928 20.1403C33.2674 20.1956 33.223 20.2164 33.1659 20.2164H30.7213H30.7149Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M35.4006 20.2649C35.1022 20.2649 34.8292 20.2096 34.5942 20.0919C34.3529 19.9742 34.1625 19.7874 34.0228 19.5244C33.8831 19.2613 33.8069 18.9153 33.8069 18.4862V14.3404C33.8069 14.2712 33.8323 14.2227 33.8831 14.1881C33.9339 14.1535 33.991 14.1396 34.0609 14.1396C34.1307 14.1396 34.1879 14.1535 34.2387 14.1881C34.2895 14.2227 34.3149 14.2712 34.3149 14.3404V18.4862C34.3149 18.9222 34.4101 19.2475 34.6069 19.4482C34.7974 19.6559 35.0641 19.7528 35.407 19.7528C35.7499 19.7528 36.0229 19.6489 36.2134 19.4482C36.4039 19.2406 36.5055 18.9222 36.5055 18.4862V14.3404C36.5055 14.2712 36.5309 14.2227 36.5817 14.1881C36.6325 14.1535 36.6896 14.1396 36.7594 14.1396C36.8293 14.1396 36.8864 14.1535 36.9372 14.1881C36.988 14.2227 37.0134 14.2712 37.0134 14.3404V18.4862C37.0134 18.9153 36.9436 19.2613 36.8039 19.5244C36.6642 19.7874 36.4737 19.9742 36.2261 20.0919C35.9848 20.2096 35.7118 20.2649 35.4133 20.2649H35.4006Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M39.3823 20.2719C39.0585 20.2719 38.7791 20.2166 38.5442 20.1127C38.3092 20.002 38.1314 19.8774 38.0045 19.739C37.8775 19.6006 37.8203 19.476 37.8203 19.3791C37.8203 19.3376 37.833 19.2891 37.8521 19.2407C37.8775 19.1922 37.9029 19.1507 37.941 19.123C37.9791 19.0953 38.0108 19.0746 38.0489 19.0746C38.0997 19.0746 38.1505 19.1092 38.2076 19.1784C38.2648 19.2476 38.3346 19.3306 38.4235 19.4206C38.5124 19.5106 38.6331 19.5937 38.7791 19.6629C38.9251 19.7321 39.122 19.7667 39.3569 19.7667C39.5918 19.7667 39.8014 19.7252 39.9728 19.6352C40.1443 19.5521 40.2713 19.4206 40.3601 19.2545C40.449 19.0884 40.4935 18.8738 40.4935 18.6178C40.4935 18.3617 40.449 18.1402 40.3538 17.9741C40.2649 17.808 40.1443 17.6765 39.9919 17.5727C39.8395 17.4688 39.6807 17.3789 39.503 17.3097C39.3252 17.2335 39.1474 17.1574 38.9632 17.0882C38.7855 17.012 38.6204 16.9221 38.468 16.8044C38.3156 16.6867 38.1949 16.5414 38.0997 16.3545C38.0045 16.1676 37.96 15.9323 37.96 15.6416C37.96 15.3371 38.0108 15.0879 38.1124 14.8941C38.214 14.7004 38.3473 14.5481 38.5061 14.4373C38.6648 14.3266 38.8426 14.2505 39.0267 14.202C39.2172 14.1536 39.395 14.1328 39.5728 14.1328C39.7125 14.1328 39.8585 14.1467 40.0109 14.1674C40.1633 14.1951 40.2967 14.2297 40.4236 14.2712C40.5506 14.3128 40.6522 14.3681 40.7348 14.4304C40.811 14.4927 40.8554 14.5619 40.8554 14.6381C40.8554 14.6796 40.8491 14.7211 40.83 14.7696C40.811 14.818 40.7856 14.8595 40.7602 14.8941C40.7284 14.9288 40.6903 14.9495 40.6395 14.9495C40.5951 14.9495 40.5316 14.9218 40.449 14.8734C40.3665 14.8249 40.2586 14.7696 40.1189 14.7142C39.9792 14.6588 39.795 14.6381 39.5728 14.6381C39.3887 14.6381 39.2109 14.6657 39.0458 14.728C38.8743 14.7834 38.7347 14.8872 38.6331 15.0256C38.5251 15.1641 38.4743 15.3579 38.4743 15.607C38.4743 15.8285 38.5188 16.0085 38.614 16.14C38.7093 16.2784 38.8299 16.3822 38.9823 16.4653C39.1347 16.5483 39.2934 16.6244 39.4712 16.6937C39.649 16.7629 39.8268 16.839 40.0109 16.929C40.1951 17.019 40.3538 17.1228 40.5062 17.2543C40.6586 17.3858 40.7792 17.5519 40.8681 17.7665C40.957 17.981 41.0078 18.2509 41.0078 18.5832C41.0078 18.9777 40.938 19.296 40.8046 19.5521C40.6649 19.8013 40.4808 19.9882 40.2395 20.1127C39.9982 20.2373 39.7188 20.2927 39.4077 20.2927L39.3823 20.2719Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M42.1441 20.2164C42.0806 20.2164 42.0171 20.1956 41.9663 20.161C41.9155 20.1264 41.8901 20.071 41.8901 20.0018V14.3472C41.8901 14.278 41.9155 14.2295 41.9663 14.1949C42.0171 14.1603 42.0743 14.1465 42.1441 14.1465C42.2076 14.1465 42.2648 14.1603 42.3156 14.1949C42.3664 14.2295 42.3981 14.278 42.3981 14.3472V20.0018C42.3981 20.071 42.3727 20.1264 42.3156 20.161C42.2648 20.1956 42.2076 20.2164 42.1441 20.2164Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M45.0208 20.2648C44.9573 20.2648 44.8938 20.251 44.8367 20.2164C44.7796 20.1818 44.7415 20.1333 44.7288 20.0641L43.1287 14.4303C43.1287 14.4303 43.1223 14.3956 43.1223 14.3749C43.1223 14.3264 43.135 14.2849 43.1668 14.2503C43.1985 14.2157 43.2366 14.188 43.2811 14.1742C43.3255 14.1534 43.3699 14.1465 43.4207 14.1465C43.4715 14.1465 43.5096 14.1603 43.5414 14.1811C43.5795 14.2019 43.6049 14.2365 43.6176 14.2918L45.0272 19.3928L46.4304 14.2918C46.4431 14.2434 46.4685 14.2088 46.5003 14.1811C46.532 14.1603 46.5701 14.1465 46.6209 14.1465C46.6717 14.1465 46.7098 14.1603 46.7606 14.1811C46.8051 14.2019 46.8432 14.2295 46.8813 14.2641C46.913 14.2988 46.9321 14.3403 46.9321 14.3887C46.9321 14.3887 46.9321 14.4026 46.9321 14.4095C46.9321 14.4164 46.9257 14.4303 46.9194 14.4372L45.3447 20.071C45.3256 20.1403 45.2875 20.1887 45.224 20.2233C45.1605 20.2579 45.1034 20.2718 45.0399 20.2718L45.0208 20.2648Z'
      fill='black'
      fill-opacity='0.5'
    />
    <path
      d='M47.2176 20.216C47.1795 20.216 47.1351 20.2091 47.0906 20.1883C47.0462 20.1676 47.0081 20.1399 46.9763 20.1053C46.9446 20.0707 46.9319 20.0291 46.9319 19.9876C46.9319 19.9668 46.9319 19.9461 46.9382 19.9322L48.532 14.2915C48.551 14.2222 48.5891 14.1738 48.6463 14.1461C48.7034 14.1184 48.7606 14.0977 48.8304 14.0977C48.9003 14.0977 48.9637 14.1115 49.0272 14.1461C49.0844 14.1807 49.1225 14.2292 49.1352 14.2845L50.7226 19.9253C50.7226 19.9253 50.7289 19.9599 50.7289 19.9738C50.7289 20.0153 50.7162 20.0568 50.6845 20.0914C50.6527 20.126 50.6146 20.1537 50.5702 20.1814C50.5257 20.2022 50.475 20.216 50.4242 20.216C50.3861 20.216 50.348 20.2022 50.3099 20.1814C50.2718 20.1606 50.2527 20.126 50.24 20.0707L49.8844 18.7902H47.7827L47.4335 20.0707C47.4208 20.1191 47.3954 20.1537 47.3573 20.1814C47.3192 20.2022 47.2811 20.216 47.2303 20.216H47.2176ZM47.897 18.3196H49.7511L48.8304 14.9697L47.9034 18.3196H47.897Z'
      fill='black'
      fill-opacity='0.5'
    />
    <defs>
      <filter
        id='filter0_d_4006_16289'
        x='0.500244'
        y='0.5'
        width='59.0022'
        height='28.9961'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4006_16289' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_4006_16289'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
